import { useQuery, UseQueryResult } from '@tanstack/react-query';

import getLead from '@/actions/leads/getLead';
import { Lead } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

export interface UseGetLeadProps {
  result: ApiResponse<Lead> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
  refetch: () => Promise<unknown>;
}

export const useGetLead = (leadId: string): UseGetLeadProps => {
  const query: UseQueryResult<ApiResponse<Lead>, Error> = useQuery({
    queryKey: ['lead-profile', leadId],
    queryFn: () => getLead(leadId),
    enabled: !!leadId,
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
    refetch: query.refetch,
  };
};
